export default "__VITE_ASSET__dbbf4d50__"